import { render } from "./HomePortfolio.vue?vue&type=template&id=55fc463a&scoped=true"
import script from "./HomePortfolio.vue?vue&type=script&lang=js"
export * from "./HomePortfolio.vue?vue&type=script&lang=js"

import "./HomePortfolio.vue?vue&type=style&index=0&id=55fc463a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fc463a"]])

export default __exports__